// src/hooks/useAuth.js
import { useState, useEffect } from 'react'
import { supabase } from '../lib/supabase'

export function useAuth() {
  const [user, setUser] = useState(undefined)
  const [role, setRole] = useState(undefined)

  useEffect(() => {
    let mounted = true

    async function fetchRole(userId) {
      // maybeSingle no lanza si la row no existe (caso raro: trigger
      // handle_new_user falló o se borró el user en public.users). En
      // ese caso role queda null y App.jsx puede redirigir limpiamente
      // en vez de quedar en loading=true para siempre.
      const { data } = await supabase
        .from('users')
        .select('role')
        .eq('id', userId)
        .maybeSingle()
      let resolved = data?.role ?? null

      // Server-side verification: si la DB dice 'admin', llamar a is_admin_caller
      // que valida role + email whitelist. Sin esto, un usuario al que se le puso
      // role='admin' por error (o privilege escalation) entraba al panel.
      // Si la RPC devuelve false, lo degradamos a 'client' (default seguro).
      if (resolved === 'admin') {
        const { data: ok } = await supabase.rpc('is_admin_caller')
        if (ok !== true) resolved = 'client'
      }
      if (mounted) setRole(resolved)
    }

    async function init() {
      const { data: { session } } = await supabase.auth.getSession()
      if (!mounted) return
      const u = session?.user ?? null
      setUser(u)
      if (u) fetchRole(u.id)
      else setRole(null)
    }

    init()

    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      if (!mounted) return
      // SIGNED_IN duplicado lo maneja init(), solo escuchar cambios reales
      if (event === 'INITIAL_SESSION') return
      const u = session?.user ?? null
      setUser(u)
      if (u) fetchRole(u.id)
      else setRole(null)
    })

    return () => {
      mounted = false
      subscription.unsubscribe()
    }
  }, [])

  const loading = user === undefined || (user !== null && role === undefined)

  return { user, role, loading }
}